module.exports = __webpack_public_path__ + "assets/img/head_success.43382c0f.jpg";